import { create } from "zustand";

export const getCurrentTahunAjaran = () => {
  const now = new Date();
  const month = now.getMonth() + 1;
  const startYear = month <= 6 ? now.getFullYear() - 1 : now.getFullYear();
  return `${startYear}_${startYear + 1}`;
};

interface ReportCardStore {
  semester: string;
  tahunAjaran: string;
  setSemester: (semester: string) => void;
  setTahunAjaran: (tahunAjaran: string) => void;
}

export const useReportCardStore = create<ReportCardStore>((set) => ({
  semester: "1",
  tahunAjaran: getCurrentTahunAjaran(),
  setSemester: (semester) => set({ semester }),
  setTahunAjaran: (tahunAjaran) => set({ tahunAjaran }),
}));
